import { render, staticRenderFns } from "./choice_echo.vue?vue&type=template&id=65d39172&scoped=true"
import script from "./choice_echo.vue?vue&type=script&lang=js"
export * from "./choice_echo.vue?vue&type=script&lang=js"
import style0 from "./choice_echo.vue?vue&type=style&index=0&id=65d39172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d39172",
  null
  
)

export default component.exports